
import { useState, useEffect } from 'react';

export interface DeviceType {
  isDesktop: boolean;
  isMobile: boolean;
  hasPointerFine: boolean;
}

export const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isDesktop: false,
    isMobile: false,
    hasPointerFine: false,
  });

  useEffect(() => {
    const checkDeviceType = () => {
      // Check if device has fine pointer (mouse/trackpad)
      const hasPointerFine = window.matchMedia('(pointer: fine)').matches;
      
      // Check if device has hover capability (desktop-like)
      const canHover = window.matchMedia('(hover: hover)').matches;
      
      // Consider desktop if has fine pointer and hover capability
      const isDesktop = hasPointerFine && canHover;
      const isMobile = !isDesktop;

      setDeviceType({
        isDesktop,
        isMobile,
        hasPointerFine,
      });
    };

    checkDeviceType();

    // Listen to media query changes
    const pointerQuery = window.matchMedia('(pointer: fine)');
    const hoverQuery = window.matchMedia('(hover: hover)');
    
    const handleChange = () => checkDeviceType();
    
    pointerQuery.addEventListener('change', handleChange);
    hoverQuery.addEventListener('change', handleChange);

    return () => {
      pointerQuery.removeEventListener('change', handleChange);
      hoverQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return deviceType;
};
